// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"a6-z"};